/* eslint-disable no-console */
import React from 'react'
import PropTypes from 'prop-types'

import { Button, Input, Group, useForm, useFela, theme } from '@fortressiq/fiq-ds'

import api from 'lib/Api'
import { saveAuditLogs } from 'helpers'
import FieldWrapper from 'components/form/FieldWrapper'

import { modalWrapperCSS } from './styles'

const IpAddressListForm = ({ handleReFetch, removeModal, setSortBy }) => {
  const { css } = useFela()

  const { register, handleSubmit, formState } = useForm({
    mode: 'all',
    reValidateMode: 'onChange',
    defaultValues: { ip_addresses: [] },
  })

  const onSubmitHandler = async formValues => {
    const params = {
      ip_address: {
        ip_address: formValues.ip_address,
      },
    }

    try {
      const data = api.post('/ip_addresses', params)
      await data
      setSortBy('updated_at')

      saveAuditLogs({
        action: 'create',
        newValues: {
          ip_address: formValues.ip_address,
        },
        previousValues: null,
        configType: 'IP Configuration',
      })

      handleReFetch()
      removeModal()
    } catch (err) {
      console.error(err)
    }
  }
  /* istanbul ignore next */
  const validateIP = ipString => {
    const regex = /^(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)){3}$/
    return regex.test(ipString) || 'Please add valid IP address!'
  }

  return (
    <div className={css(modalWrapperCSS)}>
      <form onSubmit={handleSubmit(onSubmitHandler)}>
        <FieldWrapper htmlFor='ip_address' error={formState.errors.ip_address}>
          <Input
            {...register('ip_address', { required: 'This is required.', validate: validateIP })}
            label='IP Address'
            isRequired={true}
            placeholder='Enter IP Address'
          />
        </FieldWrapper>
        <Group noEndGutter={true} justify='flex-end' style={{ marginTop: theme['default-spacer-md'] }}>
          <Button
            onClick={e => {
              e.preventDefault()
              removeModal()
            }}
            className='cancelBtn'
          >
            Cancel
          </Button>
          <Button className='addBtn' type='primary'>
            Add IP Address
          </Button>
        </Group>
      </form>
    </div>
  )
}

IpAddressListForm.defaultProps = {
  editValues: undefined,
  editId: undefined,
  isInUse: false,
}

IpAddressListForm.propTypes = {
  editId: PropTypes.number,
  editValues: PropTypes.shape({
    list: PropTypes.arrayOf(PropTypes.string),
    name: PropTypes.string,
    accessType: PropTypes.string,
  }),
  handleReFetch: PropTypes.func.isRequired,
  removeModal: PropTypes.func.isRequired,
  isInUse: PropTypes.bool,
}

export default IpAddressListForm
